import { useQuery } from 'react-query';
import axios from 'utilities/axios';

const API = {
  GET_LOGGED_PROFILE: 'users/profile',
};

export default function useProfile() {
  return useQuery('profile', () =>
    axios.get(API.GET_LOGGED_PROFILE).then((res) => res.data)
  );
}
